export const hover = function (el) {
    el.addEventListener("mouseenter", function (item) {
        el.classList.add("hover");
        if (el.querySelector(".button")) {
            el.querySelector(".button").classList.add("hover");
        }
    });
    el.addEventListener("mouseleave", function (item) {
        el.classList.remove("hover");
        if (el.querySelector(".button")) {
            el.querySelector(".button").classList.remove("hover");
        }
    });
};
